import React from 'react'
import LossSupportLandingView, {
  LossSupportLandingViewProps,
} from './views/LossSupportLandingView'
import { Route, Router } from 'react-router'
import LossSupportGuideCardsView from './views/LossSupportGuideCardsView'
// @ts-ignore
import { getHistory } from 'lib/history'
import css from './styles.scss'
import { LossSupportGuideCardsViewProps } from './views/LossSupportGuideCardsView'
import { babylossGuidesPath, babylossPath } from '../lib/urls'

export interface BabylossAppProps {
  supportContentLinks: LossSupportLandingViewProps['links']
  guides: LossSupportGuideCardsViewProps['guides']
}

export default function BabylossApp({
  guides,
  supportContentLinks,
}: BabylossAppProps) {
  const history = getHistory({ path: babylossPath, useRouter: true })

  return (
    <div className={css.root}>
      <Router history={history}>
        <Route
          path={babylossPath}
          component={() => (
            <LossSupportLandingView links={supportContentLinks} />
          )}
        />
        <Route
          path={babylossGuidesPath}
          component={() => <LossSupportGuideCardsView guides={guides} />}
        />
      </Router>
    </div>
  )
}
